/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SupportTicketFieldsOneOf { 
    deleted?: boolean;
    deletedOn?: boolean;
    deletedBy?: boolean;
    createdOn?: boolean;
    modifiedOn?: boolean;
    createdBy?: boolean;
    modifiedBy?: boolean;
    id?: boolean;
    title?: boolean;
    description?: boolean;
    status?: boolean;
    priority?: boolean;
    moduleId?: boolean;
    companyId?: boolean;
    businessUnitId?: boolean;
    departmentId?: boolean;
    additionalMetadata?: boolean;
    evidenceUrls?: boolean;
    referenceLinks?: boolean;
    assignedTo?: boolean;
    firstAssignedOn?: boolean;
    firstResponseOn?: boolean;
    resolvedOn?: boolean;
    closedOn?: boolean;
    responseDueOn?: boolean;
    resolutionDueOn?: boolean;
    reopenedCount?: boolean;
}

